<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
  </button>

  <button mat-raised-button *ngIf="site.parent_site_id" [routerLink]="'/sites/'+site.parent_site_id+'/children'" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
  </button>
</nav>

<div class="container-fluid p-0">

  <div class="card rounded-0">
    <div class="card-body p-0">

      <app-sssp-tabs *ngIf="site.id && site.sssp && site.sssp.id else noSSSP" [sssp_hash]="site.sssp.sssp_hash"></app-sssp-tabs>

      <ng-template #noSSSP>
        <div class="p-3">
          <p>Create a main {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }} using the button below.</p>

          <button type="button" mat-button (click)="onCreateSSSP()" matTooltip="Create a new master {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}." matTooltipPosition="above">
            Create Main {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}
          </button>
        </div>
      </ng-template>

    </div>
  </div>
</div>
